import { useState } from 'react'

import { meetingApi } from '../api'

const useRegenerateSummary = () => {
  const [isLoading, setIsLoading] = useState(false)

  const regenerateSummary = async (meetingId: string) => {
    setIsLoading(true)

    try {
      const meeting = await meetingApi.regenerateSummary(meetingId)
      return meeting
    } catch (error) {
      console.error('Failed to regenerate summary', error)
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, regenerateSummary }
}

export default useRegenerateSummary
